<template>
    <div>
        <div class="row mr-2">
            <div class="h1 my-2 col-11">産品管理</div>
            <div class="col-1">
                <product-editor :categories="categories" @product:created="productCreated"
                    class="btn btn-primary mt-4">新增商品</product-editor>
            </div>
        </div>
        <ul class="nav nav-tabs">
            <li class="nav-item" v-for="category, index in categories" :key="index">
                <button class="btn nav-item nav-link"
                    :class="selectedCategoryId === category.id ? `active navbarStyle` : ``"
                    @click="selectCategory(category.id)">
                    <span style="font-size:medium">{{ category.name }}</span>
                </button>
            </li>
        </ul>
        <product-list :categories="categories" :selectedCategoryId="selectedCategoryId" ref="products"></product-list>
    </div>
</template>
<script>
export default {
    data() {
        return {
            products: [],
            categories: [],
            selectedCategoryId: 1,
        }
    },
    mounted() {
        this.categories = this.fetchCategories();
    },
    methods: {
        productCreated(new_product) {
            this.$refs.products.addProduct(new_product);
        },
        fetchCategories() {
            axios.get(base_url + '/admin/api/categories')
                .then(({ data }) => {
                    console.log(data);
                    try {
                        this.categories = data;
                        this.categories.push({
                            id: 0,
                            name: '未分類'
                        })
                    } catch (e) { console.error(e) }
                })
                .catch((...error) => console.log(error));
        },
        selectCategory(id) {
            this.selectedCategoryId = id;
        }
    }
}
</script>

<style>
.navbarStyle {
    font-weight: bold;
}
</style>
